import GET from "./GET";
import inPreview from "./inPreview";
export default () => {
	const cost = GET("cost")
		? parseInt(GET("cost").replace("$", 0).trim())
		: inPreview
		? 50
		: 0;

	return Math.floor(cost);
};
